import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { queryKey } from '../../../constants/queryKey';
import { retailAdService } from 'shared/src/api';

type RetailAdsResponse = Awaited<
  ReturnType<typeof retailAdService.getRetailAd>
>;

type RetailAdsQueryOptions = Omit<
  UseQueryOptions<
    RetailAdsResponse, // TQueryFnData
    Error, // TError
    RetailAdsResponse, // TData
    readonly unknown[] // TQueryKey
  >,
  'queryKey' | 'queryFn'
>;

export const useRetailAds = (
  adSlotID = 201,
  options?: RetailAdsQueryOptions,
) => {
  return useQuery({
    queryKey: queryKey.retailAds(adSlotID),
    queryFn: () => retailAdService.getRetailAd(adSlotID),
    ...options,
  });
};
